<div
  class="min-h-screen p-4 md:p-8 bg-linear-to-br flex items-center justify-center from-surface-container-highest via-surface-container-high to-surface-container-lowest"
>
  <div class="text-center p-8 max-w-2xl mx-auto">
    <h1 class="text-2xl md:text-6xl font-normal mb-6 leading-tight">
      @if (areSessionExpired) {
        OOPS... <br />
        Sessione scaduta!
      } @else if (authError) {
        {{ 'AUTH.LOGIN.access_error_title' | translate }}
      } @else {
        <br />
        Benvenuto nel portale SIAT
      }
    </h1>
    @if (!authError) {
      <p class="text-lg md:text-xl mb-10 font-light">
        Accedi per gestire le tue informazioni e usufruire di tutti i servizi.
      </p>
    }
    <button
      mat-raised-button
      (click)="openLoginDialog()"
      class="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-full shadow-lg transition duration-300 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-blue-500/50"
    >
      Login
    </button>
  </div>
</div>
